import * as React from 'react';
import { useTheme } from '../../theme';
import { CSSRulesFunction } from '../../theme/types';
import { omit } from '../../utils';
import { AppearanceProps, textStyling } from './appearance';

type HTMLProps = Omit<
  React.HTMLAttributes<HTMLHeadingElement>,
  keyof AppearanceProps
>;
export interface Heading2Props extends AppearanceProps, HTMLProps {}

const Heading2Style: CSSRulesFunction<AppearanceProps> = (theme, props) => {
  const { h2 } = theme.tokens.typographyDefaults;
  const {
    size = h2.size,
    fontFamily = h2.fontFamily,
    letterSpacing = h2.letterSpacing,
  } = props;

  return [
    textStyling(theme, {
      ...props,
      size,
      fontFamily,
      letterSpacing,
    }),
  ];
};

const Heading2 = React.forwardRef<HTMLHeadingElement, Heading2Props>(
  function Heading2(props, ref) {
    const { theme } = useTheme();
    const rest = omit(props, [
      'size',
      'color',
      'fontWeight',
      'fontFamily',
      'textAlign',
      'letterSpacing',
      'display',
    ]);

    return <h2 css={Heading2Style(theme, props)} {...rest} ref={ref} />;
  }
);

export default Heading2;
